import { render } from "./si-chip.component.vue?vue&type=template&id=e17408fc&ts=true"
import script from "./si-chip.component.vue?vue&type=script&lang=ts"
export * from "./si-chip.component.vue?vue&type=script&lang=ts"

import "./si-chip.component.vue?vue&type=style&index=0&id=e17408fc&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__